import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'

import App from './app'
import serverData from './utils/server-data'
import setupAnalytics from './utils/fpti'

import { ContextProvider as GriffinContextProvider } from '@paypalcorp/worldready-react'
import screenMapper from './screens/screen-mapper'
import Home from './screens/home'

const renderView = () => {
  const {
    isFlow = false,
    fpti = null,
    view: { name: viewName } = {},
  } = serverData
  let screen = null
  if (viewName) {
    screen = screenMapper[viewName]
  }
  if (fpti) {
    setupAnalytics()
  }

  let root = document.getElementById('root')
  const flow = document.getElementById('flow')

  if (!root) {
    root = document.createElement('div')
    document.body.appendChild(root)
  }

  ReactDOM.render(
    <GriffinContextProvider locale={serverData.locality.locale}>
      {isFlow && Screen ? (
        <Suspense fallback={<div>...</div>}>
          <Home isFlow {...screen.props}>
            <screen.view {...screen.props} />
          </Home>
        </Suspense>
      ) : (
        <Suspense fallback={<div>...</div>}>
          <App path="*" />
        </Suspense>
      )}
    </GriffinContextProvider>,
    isFlow ? flow : root,
  )
}

export default renderView
